import { Localize } from './utilities/localize';
import { FormValidation } from './utilities/form-validation';

class ContactForm {
  constructor (node) {
    this.contactForm = node;
    // The following eslint-disable-next-line is necessary due to `contactFormTopics` being specified in `src/packages/gs1_form/Resources/Private/Templates/ContactForm/Form.html`.
    // eslint-disable-next-line no-undef
    this.contactFormTopics = contactFormTopics;
    this.glnField = this.contactForm.querySelector('#contactForm--gln');
    this.glnLabel = this.contactForm.querySelector(`label[for="${this.glnField.id}"]`);
    this.uploadField = this.contactForm.querySelector('#contactForm--fileupload');
    this.uploadLabel = this.contactForm.querySelector(`label[for="${this.uploadField.id}"]`);
    this.topicField = this.contactForm.querySelector('#contactForm--topic');
    this.subTopicField = this.contactForm.querySelector('#contactForm--subTopic');
    this.requiredSelectErrorText = Localize('js.contactForm.error.requiredSelect');
    this.requiredEmailErrorText = Localize('js.contactForm.error.email');
    this.formElement = this.contactForm.querySelector('form');

    this.requiredInputErrorText = Localize('js.contactForm.error.requiredInput');

    document.addEventListener('DOMContentLoaded', this.populateTopics.bind(this));
    this.topicField.addEventListener('change', this.populateSubTopics.bind(this));
    this.topicField.addEventListener('change', this.handleMandatoryFields.bind(this));
    this.subTopicField.addEventListener('change', this.handleMandatoryFields.bind(this));

    this.topicField.addEventListener('change', (event) => {
      const selectedTopic = event.target.options[this.topicField.selectedIndex].getAttribute('data-topic-position');
      this.addSuggestionContainer(this.contactFormTopics[selectedTopic].suggested_articles, this.contactFormTopics[selectedTopic].suggested_articles_title, event.target);
      this.saveTopicChoice(event);
    });

    this.subTopicField.addEventListener('change', (event) => {
      const selectedTopic = this.topicField.options[this.topicField.selectedIndex].getAttribute('data-topic-position');
      const selectedSubTopic = event.target.options[this.subTopicField.selectedIndex].getAttribute('data-subtopic-position');
      this.addSuggestionContainer(this.contactFormTopics[selectedTopic].subtopics[selectedSubTopic].suggested_articles, this.contactFormTopics[selectedTopic].subtopics[selectedSubTopic].suggested_articles_title, event.target);
      this.saveTopicChoice(event);
    });

    this.requiredFields = this.contactForm.querySelectorAll('[required]');
    this.requiredFields.forEach((field) => {
      field.addEventListener('input', () => this.handleFormValidation(field));
      field.addEventListener('blur', () => this.handleFormValidation(field));
    });

    this.formElement.setAttribute('novalidate', 'novalidate');

    this.formElement.addEventListener('submit', (event) => {
      if (document.activeElement && this.contactForm.contains(document.activeElement)) {
        document.activeElement.blur();
      }

      const isValid = this.validateForm();

      if (!isValid) {
        event.preventDefault();
        const firstInvalid = this.contactForm.querySelector('.c-form-input--error');
        if (firstInvalid) {
          firstInvalid.focus();
        }
      }
    });

    document.addEventListener('DOMContentLoaded', this.handleUrlParameters.bind(this));

    document.addEventListener('DOMContentLoaded', this.loadTopicChoice.bind(this));
  }

  populateTopics() {
    this.topicField.innerHTML = '';
    Object.entries(this.contactFormTopics).forEach(([index, topic]) => {
      const topicOption = new Option(topic.name, topic.uid);
      topicOption.setAttribute('data-topic-position', index);
      this.topicField.appendChild(topicOption);
    });
  }

  populateSubTopics() {
    this.subTopicField.innerHTML = '';

    if (this.topicField.selectedIndex !== 0) {
      const selectedTopic = this.topicField.options[this.topicField.selectedIndex].getAttribute('data-topic-position');
      Object.entries(this.contactFormTopics[selectedTopic].subtopics).forEach(([index, subTopic]) => {
        const subTopicOption = new Option(subTopic.name, subTopic.uid);
        subTopicOption.setAttribute('data-subtopic-position', index);
        this.subTopicField.appendChild(subTopicOption);
      });
    }
  }

  handleMandatoryFields() {
    const mandatoryInfo = document.createElement('span');
    mandatoryInfo.textContent = ' *';
    mandatoryInfo.setAttribute('data-mandatory', 'true');

    const selectedTopic = this.topicField.options[this.topicField.selectedIndex].getAttribute('data-topic-position');
    const selectedSubTopic = this.subTopicField.options[this.subTopicField.selectedIndex].getAttribute('data-subtopic-position');

    if (this.contactFormTopics[selectedTopic].subtopics[selectedSubTopic].require_upload === true) {
      if (!this.uploadLabel.querySelector('[data-mandatory]')) {
        const uploadFieldMandatory = mandatoryInfo.cloneNode(true);
        this.uploadLabel.insertAdjacentElement('beforeend', uploadFieldMandatory);
      }
      this.uploadField.setAttribute('required', 'required');
    } else {
      if (this.uploadLabel.querySelector('[data-mandatory]')) {
        this.uploadLabel.querySelector('[data-mandatory]').remove();
      }
      this.uploadField.removeAttribute('required');
    }



    if (this.contactFormTopics[selectedTopic].subtopics[selectedSubTopic].require_gln === true) {
      if (!this.glnLabel.querySelector('[data-mandatory]')) {
        const glnFieldMandatory = mandatoryInfo.cloneNode(true);
        this.glnLabel.insertAdjacentElement('beforeend', glnFieldMandatory);
      }
      this.glnField.setAttribute('required', 'required');
    } else {
      if (this.glnLabel.querySelector('[data-mandatory]')) {
        this.glnLabel.querySelector('[data-mandatory]').remove();
      }
      this.glnField.removeAttribute('required');
    }
  }

  /**
   * Create suggestion container
   *
   * @param suggestions - The list of suggestions to add to the container
   * @param suggestedArticlesTitle - The (optional) title for the suggestion container
   * @returns {HTMLDivElement}
   */
  createSuggestionContainer(suggestions, suggestedArticlesTitle) {
    // Prep dynamic suggestion container
    const suggestionArticlesElement = document.createElement('div');
    suggestionArticlesElement.id = 'suggestionContainer';
    suggestionArticlesElement.classList.add('c-list-group');
    suggestionArticlesElement.classList.add('c-suggested-articles');
    const suggestionArticlesElementHeaderContainer = document.createElement('div');
    suggestionArticlesElementHeaderContainer.classList.add('c-list-group__header');
    const suggestionArticlesElementHeader = document.createElement('span');
    suggestionArticlesElementHeader.classList.add('u-headline');
    suggestionArticlesElementHeader.classList.add('u-headline--small');
    suggestionArticlesElementHeader.textContent = `${suggestedArticlesTitle}`;
    const suggestionArticlesElementBody = document.createElement('div');
    suggestionArticlesElementBody.classList.add('c-list-group__container');
    const suggestionArticlesElementList = document.createElement('ul');
    suggestionArticlesElementList.classList.add('c-list-group__content-list');

    suggestionArticlesElement.insertAdjacentElement('afterbegin', suggestionArticlesElementHeaderContainer);
    suggestionArticlesElementHeaderContainer.insertAdjacentElement('afterbegin', suggestionArticlesElementHeader);
    suggestionArticlesElement.insertAdjacentElement('beforeend', suggestionArticlesElementBody);
    suggestionArticlesElementBody.insertAdjacentElement('afterbegin', suggestionArticlesElementList);
    suggestions.forEach((suggestionText) => {
      suggestionArticlesElementList.insertAdjacentHTML('afterbegin', suggestionText);
    });

    return suggestionArticlesElement;
  }

  /**
   * Add suggestion container to site, on the fly
   *
   * @param articles - The list of articles to output
   * @param articlesTitle - The (optional) title for the box (can come from TYPO3)
   * @param insertPosition - The element after which it should be inserted to
   */
  addSuggestionContainer(articles, articlesTitle, insertPosition) {
    const suggestedArticles = articles;

    const suggestionContainer = document.querySelector('#suggestionContainer');
    if (suggestedArticles.length > 0) {
      const suggestionTexts = [];
      for (let i = 0; i < suggestedArticles.length; i++) {
        suggestionTexts[i] = `<li class="c-list-group-content-list__item">${suggestedArticles[i].bodytext}</li>`;
      }

      // Remove eventual pre-existing suggestion elements (prevents double display of previously shown help articles)
      if (suggestionContainer) {
        suggestionContainer.remove();
      }

      insertPosition.insertAdjacentElement('afterend', this.createSuggestionContainer(suggestionTexts, articlesTitle));
    } else {
      if (suggestionContainer) {
        suggestionContainer.remove();
      }
    }
  }

  handleFormValidation(el) {
    let isValid = true;
    const validationMessage = el.closest('.c-form-group').querySelector('.c-form-validation');
    if (validationMessage) {
      validationMessage.remove();
    }

    if (el.type.includes('select')) {
      if (el.selectedIndex === 0) {
        el.classList.remove('c-form-input--success');
        el.classList.add('c-form-input--error');
        el.insertAdjacentElement('afterend', new FormValidation(el).formValidationMessage('error', this.requiredSelectErrorText));
        isValid = false;
      } else {
        el.classList.remove('c-form-input--error');
        el.classList.add('c-form-input--success');
        el.insertAdjacentElement('afterend', new FormValidation(el).formValidationMessage('success', ''));
      }
      new FormValidation(el).customValidity('select', this.requiredSelectErrorText);
    } else {
      if ((el.hasAttribute('required') || el.id === 'contactForm--emailAddress') && !el.checkValidity()) {
        el.classList.remove('c-form-input--success');
        el.classList.add('c-form-input--error');
        const errorText = el.id === 'contactForm--emailAddress' ? this.requiredEmailErrorText : this.requiredInputErrorText;
        el.insertAdjacentElement('afterend', new FormValidation(el).formValidationMessage('error', errorText));
        isValid = false;
      } else {
        el.classList.remove('c-form-input--error');
        el.classList.add('c-form-input--success');
        el.insertAdjacentElement('afterend', new FormValidation(el).formValidationMessage('success', ''));
      }
    }

    return isValid;
  }

  validateForm() {
    let formIsValid = true;

    this.requiredFields.forEach((field) => {
      const msg = field.closest('.c-form-group').querySelector('.c-form-validation');
      if (msg) {
        msg.remove();
      }
    });

    this.requiredFields.forEach((field) => {
      if (!this.handleFormValidation(field)) {
        formIsValid = false;
      }
    });

    const focused = document.activeElement;
    if (focused && this.contactForm.contains(focused) && !Array.from(this.requiredFields).includes(focused)) {
      if (!this.handleFormValidation(focused)) {
        formIsValid = false;
      }
    }

    return formIsValid;
  }


  handleUrlParameters() {
    const currentUrlParameters = window.location.search;
    const params = new URLSearchParams(currentUrlParameters);

    const topic = params.get('tx_gs1form_contactform[topic]');
    const subTopic = params.get('tx_gs1form_contactform[subtopic]');
    if (topic) {
      this.topicField.value = topic;
      this.topicField.dispatchEvent(new Event('change'));

      if (subTopic) {
        this.subTopicField.value = subTopic;
        this.subTopicField.dispatchEvent(new Event('change'));
      }
    }
  }

  saveTopicChoice(event) {
    const el = event.currentTarget;
    if (el === this.topicField) {
      const selectedTopic = el.value;
      window.sessionStorage.setItem('tx_gs1form_contactForm[topic]', selectedTopic);
    }

    if (el === this.subTopicField) {
      const selectedSubTopic = el.value;
      window.sessionStorage.setItem('tx_gs1form_contactForm[subTopic]', selectedSubTopic);
    }
  }

  loadTopicChoice() {
    const currentPath = window.location.pathname;
    const referrerPath = new URL(document.referrer, window.location.origin).pathname;

    if (referrerPath !== currentPath) {
      window.sessionStorage.removeItem('tx_gs1form_contactForm[topic]');
      window.sessionStorage.removeItem('tx_gs1form_contactForm[subTopic]');
      return;
    }

    const selectedTopic = window.sessionStorage.getItem('tx_gs1form_contactForm[topic]');
    const selectedSubTopic = window.sessionStorage.getItem('tx_gs1form_contactForm[subTopic]');

    if (selectedTopic) {
      this.topicField.value = selectedTopic;
      this.topicField.dispatchEvent(new Event('change'));
    }

    if (selectedSubTopic) {
      this.subTopicField.value = selectedSubTopic;
      this.subTopicField.dispatchEvent(new Event('change'));
    }
  }
}

const contactForms = document.querySelectorAll('[data-contact-form]');
contactForms.forEach((contactForm) => {
  new ContactForm(contactForm);
});
